import { render } from "./LeaveList.vue?vue&type=template&id=6108426a&scoped=true"
import script from "./LeaveList.vue?vue&type=script&lang=js"
export * from "./LeaveList.vue?vue&type=script&lang=js"

import "./LeaveList.vue?vue&type=style&index=0&id=6108426a&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\shame\\.codex\\.chatgpt-projects\\g-p-6a9e6467fc748191a03e695eb5ba59d5\\build-work\\hr-dependent-frontend\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6108426a"]])

export default __exports__